import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { BrandingProvider } from "@/context/BrandingContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Orders from "@/pages/Orders";
import Packages from "@/pages/Packages";
import Reports from "@/pages/Reports";
import Users from "@/pages/Users";
import Branches from "@/pages/Branches";
import Settings from "@/pages/Settings";
import PettyCash from "@/pages/PettyCash";

const Shell = ({ children }) => (
  <ProtectedRoute>
    <Layout>{children}</Layout>
  </ProtectedRoute>
);

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrandingProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/" element={<Shell><Dashboard /></Shell>} />
              <Route path="/pesanan" element={<Shell><Orders /></Shell>} />
              <Route
                path="/kas"
                element={
                  <ProtectedRoute roles={["staff", "admin", "keuangan", "super_admin"]}>
                    <Layout><PettyCash /></Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/paket"
                element={
                  <ProtectedRoute roles={["admin", "staff"]}>
                    <Layout><Packages /></Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/laporan"
                element={
                  <ProtectedRoute roles={["admin", "keuangan", "super_admin"]}>
                    <Layout><Reports /></Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/cabang"
                element={
                  <ProtectedRoute roles={["super_admin"]}>
                    <Layout><Branches /></Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/pengguna"
                element={
                  <ProtectedRoute adminOnly>
                    <Layout><Users /></Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/pengaturan"
                element={
                  <ProtectedRoute roles={["admin", "super_admin", "staff"]}>
                    <Layout><Settings /></Layout>
                  </ProtectedRoute>
                }
              />
            </Routes>
          </BrowserRouter>
          <Toaster position="top-right" richColors />
        </BrandingProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
